import { Controller } from "@hotwired/stimulus"

const FIELDS = "input, textarea, select"
const DESTROY_FLAG = "input[name*='[_destroy]']"

export default class extends Controller {
  static targets = ["rows", "template", "row", "search", "number", "noResults"]

  connect() {
    this.renumber()
  }

  add(event) {
    event.preventDefault()
    // crypto.randomUUID() is undefined here — the app serves plain http on a custom domain (non-secure context).
    this.newIndex = (this.newIndex || Date.now()) + 1
    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    row.querySelectorAll(FIELDS).forEach((field) => {
      if (field.name) field.name = field.name.replace(/NEW_RECORD/g, this.newIndex)
      if (field.id) field.id = field.id.replace(/NEW_RECORD/g, this.newIndex)
    })
    this.rowsTarget.appendChild(row)
    this.renumber()
    row.querySelector(FIELDS)?.focus()
  }

  remove(event) {
    event.preventDefault()
    const row = this.rowTargets.find((candidate) => candidate.contains(event.target))
    const destroyFlag = row.querySelector(DESTROY_FLAG)
    if (destroyFlag) {
      destroyFlag.value = "1" // persisted row: flag for server-side destroy instead of dropping the node
      row.hidden = true
    } else {
      row.remove()
    }
    this.renumber()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    this.rowTargets.forEach((row) => {
      if (this.destroyed(row)) return // destroyed rows stay hidden regardless of the query
      const haystack = Array.from(row.querySelectorAll(FIELDS), (field) => field.value).join(" ")
      row.hidden = query !== "" && !haystack.toLowerCase().includes(query)
    })
    if (this.hasNoResultsTarget) {
      this.noResultsTarget.hidden = this.rowTargets.some((row) => !row.hidden)
    }
  }

  renumber() {
    if (!this.hasNumberTarget) return
    let index = 0
    this.rowTargets.forEach((row) => {
      const cell = row.querySelector("[data-editable-table-target='number']")
      if (cell && !this.destroyed(row)) cell.textContent = ++index
    })
  }

  destroyed(row) {
    return row.querySelector(DESTROY_FLAG)?.value === "1"
  }
}
